// start:ng42.barrel
import './team-diary.directive';
// end:ng42.barrel

